<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>其他</el-breadcrumb-item>
      <el-breadcrumb-item>自定义配置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="最终客户现场拜访注意事项"
          name="first"
          v-if="hasAuth('customConfigVisit')"
          ><CustomerVisit></CustomerVisit
        ></el-tab-pane>
        <el-tab-pane
          label="小程序商品详情页底部通用说明"
          name="second"
          v-if="hasAuth('customConfigCommodity')"
          ><CommodityMp></CommodityMp
        ></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CustomerVisit from './CustomerVisit'
import CommodityMp from './CommodityMp'
import { hasAuth } from '@/permission'

export default {
  components: {
    CustomerVisit,
    CommodityMp,
  },
  data() {
    return {
      hasAuth,
      activeName: 'first',
    }
  },
}
</script>